import { Box, Container, Fade, Paper } from '@mui/material';
import { useState } from 'react';
import Balance from '../../components/balance';
import TableHeaderTitle from '../../components/TableHeaderTitle';
import TransactionTable from './components/TransactionTable';
import Document from './components/document';

const TransactionsPage = () => {
  const [documentData, setDocumentData] = useState();
  return (
    <Container
      maxWidth={false}
      sx={{
        flexGrow: 1,
        width: '100%',
        maxWidth: '100%',
        minWidth: 0,
        boxSizing: 'border-box',
        padding: {
          xs: '72px 12px 24px 12px !important',
          sm: '80px 16px 28px 16px !important',
          md: '100px 24px 36px 24px !important',
          lg: '110px 40px 40px 40px !important',
        },
        background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
        minHeight: '100vh',
        overflowX: 'hidden',
        overflowY: 'auto',
      }}
    >
      {/* Main Dashboard Container */}
      <Paper
        elevation={0}
        sx={{
          width: '100%',
          maxWidth: '100%',
          minWidth: 0,
          borderRadius: { xs: 2, sm: 3, md: 4 },
          background: 'linear-gradient(135deg, rgba(255,255,255,0.95) 0%, rgba(255,255,255,0.8) 100%)',
          backdropFilter: 'blur(20px)',
          border: '1px solid rgba(255,255,255,0.3)',
          boxShadow: '0 20px 40px rgba(0,0,0,0.08)',
          overflow: 'hidden',
          position: 'relative',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            height: '6px',
            background: 'linear-gradient(90deg, #1e3c72 0%, #2a5298 25%, #3b82f6 50%, #2a5298 75%, #1e3c72 100%)',
          },
        }}
      >
        <Document listOfData={documentData} />
        <Box
          sx={{
            width: '100%',
            maxWidth: '100%',
            minWidth: 0,
            p: { xs: 2, sm: 3, md: 4 },
            pb: 2,
            background: 'linear-gradient(135deg, rgba(30, 60, 114, 0.03) 0%, rgba(42, 82, 152, 0.06) 100%)',
            borderBottom: '1px solid rgba(226, 232, 240, 0.8)',
          }}
        >
          <Fade in={true} timeout={600}>
            <Box sx={{ width: '100%', maxWidth: '100%', minWidth: 0 }}>
              <Balance />
              <Paper
                elevation={0}
                sx={{
                  width: '100%',
                  maxWidth: '100%',
                  minWidth: 0,
                  mt: { xs: 2, sm: 2.5, md: 3 },
                  borderRadius: { xs: 2, sm: 3 },
                  background: 'rgba(255,255,255,0.7)',
                  backdropFilter: 'blur(10px)',
                  border: '1px solid rgba(226, 232, 240, 0.8)',
                  overflow: 'hidden',
                  position: 'relative',
                }}
              >
                {/* Table Header */}
                <Box
                  sx={{
                    p: { xs: 2, sm: 2.5, md: 3 },
                    pb: 2,
                    background: 'linear-gradient(135deg, rgba(248, 250, 252, 0.8) 0%, rgba(241, 245, 249, 0.9) 100%)',
                    borderBottom: '1px solid rgba(226, 232, 240, 0.6)',
                  }}
                >
                  <TableHeaderTitle title="İşlemler Listesi" />
                </Box>

                {/* Table Content - scroll sadece bu kutuda, sayfa x scroll yapmaz */}
                <Box
                  sx={{
                    p: { xs: 1.5, sm: 2, md: 3 },
                    width: '100%',
                    maxWidth: '100%',
                    minWidth: 0,
                    overflowX: 'auto',
                    WebkitOverflowScrolling: 'touch',
                  }}
                >
                  <TransactionTable setDocumentData={setDocumentData} />
                </Box>
              </Paper>
            </Box>
          </Fade>
        </Box>
      </Paper>
    </Container>
  );
};

export default TransactionsPage;
